import { hasCrremDashboardData } from "../lib/parseCrremDashboardApi";
import { useCrremDashboardScenarios } from "./useCrremDashboardScenarios";

export const useHasCrremPathwayData = (projectId: string) => {
  const dashboardQuery = useCrremDashboardScenarios(projectId);
  return {
    hasData: hasCrremDashboardData(dashboardQuery.data),
    isLoading: !dashboardQuery.isFetched,
  };
};
